<template>
<div>
  <div class="frameBg" v-show="showModal2"></div>
    <div class="frameInput" v-show="claimBox" style="margin-top:-356px;">
        <div class="frameHead indexHead clear">
          <p class="l">Contraband Statement</p><p @click="getClose" class="r" style="font-size:26px;">×</p>
        </div>
        <div class="content">
          <h3 class="marBot10">Freightshop does not accept any contraband goods stipulated by China. The following are the goods we do not accept:</h3>
          <p>● Valuable securities that are difficult to estimate (bill of lading, verification form, passport, quota certificate, permit, license, personal certificate, bill of exchange, invoice, etc.)</p>
          <p>● Easily lost valuables (domestic or foreign currency (cash), gold and silver ornaments, artificial jewelry, etc.)</p>
          <p>● Various dangerous goods that are flammable, explosive, corrosive, toxic, strong acid, alkaline and radioactive (matches, detonators, gunpowder, firecrackers, gasoline, diesel, kerosene, alcohol (liquids and solids), sulphuric acid, hydrochloric acid, nitric acid, organic solvents, pesticides, and other chemical products listed in the "Chemical Dangerous Goods Practical Handbook" published by the Chemical Industry Press.)</p>
          <p>● Potent poisons, narcotic drugs and spiritual items (arsenic, opium, morphine, cocaine, heroin, marijuana, etc.)</p>
          <p>● Articles prohibited by circulation or shipment by national laws (cultural relics, weapons, ammunition, simulated weapons, etc.)</p>
          <p>● Medical sample (diagnose samples, blood samples, urine samples, human tissues, etc.)</p>
          <p>● Antiques and crafts (Ming Dynasty porcelain, exquisite glass products, etc.)</p>
          <p>● Brand-name products, imitation brand products, second-hand personal items (old items)</p>
          <p>● Food</p>
          <p>● Newspapers and books containing reactionary, obscene or indecent content, images, promotional materials, audio-visual products, laser disc (VCD, DVD, LD), computer disks, CDs, etc.</p>
          <p>● Obstruction of public health, such as bones (including burned bones), unskinned hides, unmedicated animal bones, etc.</p>
          <p>● Animals, plants and their specimens</p>
          <p>● White powder with indistinguishable ingredients</p>
          <p>● Fragile products, glass products</p>
          <p>● Other aviation contraband</p>
          <p>● Powdered items (regardless of color), liquid (regardless of the packaging used), outsourced goods with hazard symbols, no proof of national audio-visual publishing audio and video products (including CD, VCD), tools, durians, gas-fired machines, any goods (including toys) involving the concept of "weapons" and "firearms", batteries or products with a motor power exceeding 100W, etc.</p>
          <p>● Exhibitor goods</p>
        </div>
        <div class="framePwBtn">
              <a style="margin-left:40%;" class="sureA l" @click="getClose">OK</a>
          </div>  
      </div>
</div>
     
</template>
<script>
  export default {
    props: {
      titNames:'',
      titUrls:''
    },
    data () {
      return {
        showModal2:false,
        claimBox:false,
      }
    },
    mounted:function(){
    },

    methods:{
      getClose(){ //关闭弹框
        this.showModal2=false
        this.claimBox=false
      },
      //打开弹框
      clkOpenBox(){
        this.showModal2=true
        this.claimBox=true
      },


    }

  }
</script>
<style lang="css" scoped>
  @import "../../../assets/css/frame.css";
  .frameInput .content label{margin:0 10px}
  .frameInput .content label h3{margin-bottom:5px;}
  .frameInput .content label p{color:#666;font-size:12px;margin:0 10px;}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/contraband.vue